(ns frontend.view.settings2.reporting-db.view
  (:require [common.localization :as loc]
            [common.util :as cu]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.view.not-found :as not-found]
            [frontend.view.settings2.reporting-db.event :as event]
            [frontend.view.settings2.reporting-db.sub :as sub]
            [re-frame.core :as rf]
            [ui.components.breadcrumbs.view :as breadcrumbs]
            [ui.components.button.view :as button]
            [ui.components.loading-spinner.view :as spinner]
            [ui.components.text.view :as text]
            [ui.editors.data-input :as data-input]
            ))

(defn read-only
  [label value]
  [:div
   [text/label label]
   [text/field-value value]])

(defn password-view
  []
  (let [pw @(rf/subscribe [::sub/new-password])
        error @(rf/subscribe [::sub/new-pw-error])
        valid-pw? (and (not error)
                       (not (cu/blank-value? pw)))
        processing? @(rf/subscribe [::sub/processing])]
    [:div
     {:class "flex flex-col gap-3 flex-1"}
     [text/label (loc/tr :reset-password)]
     [data-input/view
      {:data-type :data.type/password
       :value     pw
       :on-change #(rf/dispatch [::event/new-password-input %])}]
     [:span
      {:class "text-danger-regular"}
      error]

     #_[text/label (loc/tr :your-current-password)]
     #_[data-input/view
        {:data-type :data.type/password
         :value     current-pw
         :on-change #(rf/dispatch [::event/current-password-input %])}]

     [:div
      (if processing?
        [button/secondary-hollow
         {}
         [spinner/circle]]
        [button/primary-solid
         {:disabled? (or (not valid-pw?)
                         #_(cu/blank-value? current-pw))
          :on-click  #(rf/dispatch [::event/reset-password! pw])}
         (loc/tr :reset-password)])]]))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [_e]
                 (routing/set-view! [:account-settings :tab-key "config"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/reporting-db)]])

(defn config-view
  []
  (let [tenant @session/tenant]
    [:div
     [zap-toolbar/view nil
      breadcrumbs
      nil nil]
     [:div
      {:class "px-4 py-6 lg:mx-auto lg:w-3xl"}
      [read-only (loc/tr :reporting-db-host) (:tenant/reporting-db-read-host tenant)]
      [read-only (loc/tr :reporting-db-port) (:tenant/reporting-db-read-port tenant)]
      [read-only (loc/tr :reporting-db-database) (:tenant/reporting-db-database-name tenant)]
      [read-only (loc/tr :reporting-db-username) (:tenant/reporting-db-read-username tenant)]
      [password-view]]]))



(defmethod routing/render-view :settings/reporting-db
  [_]
  (if true
    [default-page-layout/view
     [config-view]]
    [not-found/not-found-view]))
